export type PostEmployeeProfessionApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostEmployeeProfessionApiArg = {
  body: {
    description: string;
    type?: string | null;
  } | null;
};
export type GetEmployeeProfessionApiResponse =
  | /** status 200 Standard response */ ({
      description?: string | null;
      type?: {
        typeKey: string;
        typeLabel: string;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetEmployeeProfessionApiArg = {
  /** Name */
  id: string;
};
export type DeleteEmployeeProfessionApiResponse = unknown;
export type DeleteEmployeeProfessionApiArg = {
  /** Name */
  id: string;
};
export type PatchEmployeeProfessionApiResponse = unknown;
export type PatchEmployeeProfessionApiArg = {
  /** Name */
  id: string;
  body: {
    description: string;
    type?: string | null;
  } | null;
};
export type PostEmployeeProfessionSetAsActiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeProfessionSetAsActiveApiArg = {
  /** Name */
  professionId: string;
};
export type PostEmployeeProfessionSetAsInactiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeProfessionSetAsInactiveApiArg = {
  /** Name */
  professionId: string;
};
export type GetEmployeeWorkProfessionsListApiResponse =
  | /** status 200 Standard response */ ({
      professions?: ({
        id?: string | null;
        description?: string | null;
        isActive?: boolean | null;
        type?: {
          typeKey: string;
          typeLabel: string;
        } | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ undefined;
/** A 204 arrives as `null`, not `undefined` — RTK maps an empty response body to null. */
export type GetEmployeeProfessionTypesApiResponse =
  | /** status 200 Standard response */ ({
      key: string;
      label: string;
    } | null)[]
  | /** status 204 Standard response */ null
  | undefined;
